query ListGeometryTypeRevisions (
    $id: ID!
) {
    geometryType(
        id: $id
        resolution: ["public", "latest"]
    ) {
        id
        revisions {
            createdAt
            id
            tags
        }
    }
}
